import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { ThemeModeProvider } from '../_metronic/partials'
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";
import trGregorian from 'cldr-dates-full/main/tr/ca-gregorian.json';
import dateFields from "cldr-dates-full/main/tr/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/tr/timeZoneNames.json";
import numbers from "cldr-numbers-full/main/tr/numbers.json";
import { load } from "@progress/kendo-react-intl";
import { HasToken, GotoSSO, SaveInitialUrl } from './modules/auth/components/SsoComponent'

load(trGregorian, dateFields, timeZoneNames, likelySubtags, currencyData, weekData, numbers);

const App = () => {
  const [initial] = useState(SaveInitialUrl());

  useEffect(() => {
    if (!HasToken())
      GotoSSO();
  }, [initial])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            <Outlet />
            <MasterInit />
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export { App }
